import React from "react";
import {Outlet, Navigate} from "react-router-dom";
import { LOAD } from "../constants";

const PublicRoute=()=>{
  let isAuthenticated = localStorage.getItem("AccessToken");
  return isAuthenticated ? <Navigate to={LOAD}/>:<Outlet/>
}

export default PublicRoute;